import React from "react";
import List from "../../shared/List";
import helpers from "../../shared/helpers";
import EventPromoList from "./EventPromoList";
import JobPromoList from "./JobPromoList";
import PromoCodeForm from "./Form";

export default function Events(){

  return (<>
    <PromoCodeForm />
    <h2>Events Promo Codes</h2>
    <EventPromoList type="used" limit={500} title="Event Promo Codes Used"/>
    <EventPromoList type="available" limit={500} title="Event Promo Codes Available"/>

    <h2>Job Listings Promo Codes</h2>
    <JobPromoList type="available" limit={500} title="Job Promo Codes Available"/>
    <JobPromoList type="used" limit={500} title="Job Promo Codes Used"/>
  </>);
}
